import type { Profile } from "../types";

const DIAS: Array<keyof NonNullable<Profile["hours"]>> = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

/** "Aberto · fecha às 18:00" / "Fechado hoje" a partir dos horários do formulário. */
export const resumoDeHoje = (hours: Profile["hours"]): { texto: string; aberto: boolean } | null => {
  if (!hours) return null;
  const hoje = hours[DIAS[new Date().getDay()]];
  const faixas = Array.isArray(hoje) ? hoje : hoje ? [hoje] : [];
  const validas = faixas.map((f) => String(f).trim()).filter((f) => f && !/fechado|closed/i.test(f));
  if (validas.length === 0) return { texto: "Fechado hoje", aberto: false };
  const ultima = validas[validas.length - 1];
  const fecha = ultima.split(/[-–]/).pop()?.trim();
  return { texto: fecha ? `Aberto · fecha às ${fecha}` : "Aberto hoje", aberto: true };
};

export type ItemDeCompletude = { rotulo: string; ok: boolean };

/** Itens que a prancheta lista em "Completude do perfil", calculados do formulário. */
export const itensDeCompletude = (p: Profile): ItemDeCompletude[] => {
  const extras = (p.secondaryCategories ?? []).length;
  return [
    { rotulo: "Nome e categoria principal", ok: Boolean(p.name && p.category) },
    { rotulo: extras > 0 ? `Categorias adicionais (${extras})` : "Categorias adicionais", ok: extras > 0 },
    { rotulo: "Data de abertura", ok: Boolean(p.openingDate) },
    { rotulo: "Telefone e site", ok: Boolean(p.phone && p.website) },
    { rotulo: "Coordenadas no mapa", ok: typeof p.latitude === "number" && typeof p.longitude === "number" },
    { rotulo: "Descrição do negócio", ok: (p.description ?? "").trim().length >= 250 },
    { rotulo: "Horário de funcionamento", ok: Boolean(p.hours && Object.values(p.hours).some((h) => (Array.isArray(h) ? h.length > 0 : Boolean(h)))) },
  ];
};
